import Box from '@mui/material/Box';

import { ResetMfaCard } from '@/components/mfa/components/display/mfaUserSettings/resetMfaCard';
import { SetupMfaCard } from '@/components/mfa/components/display/mfaUserSettings/setupMfaCard';
import { useMfaContext } from '@/components/mfa/providers/mfaProvider';
import { DashboardContentLayout } from '@/layouts/dashboardContent';
import { SettingsLayout } from '@/layouts/settings';

export default function UserSettingsMfaPage() {
  const { userMfaConfigured } = useMfaContext();

  return (
    <DashboardContentLayout disableGrid={true} title="Settings / Multi-factor authentication">
      <SettingsLayout>
        <Box sx={{ maxWidth: 664 }}>{userMfaConfigured ? <ResetMfaCard /> : <SetupMfaCard />}</Box>
      </SettingsLayout>
    </DashboardContentLayout>
  );
}
